export const LOCALE_DATE_FORMAT = 'll';
export const LOCALE_TIME_FORMAT = 'LT';
export const LOCALE_DATETIME_FORMAT = 'lll';
export const SERVER_DATE_FORMAT = 'YYYY-MM-DD';
export const SERVER_TIME_FORMAT = 'HH:mm:ss';
export const SERVER_DATETIME_FORMAT = 'YYYY-MM-DD HH:mm:ss';
export const MONTH_DAY_YEAR_FORMAT = 'MM-DD-YYYY';
export const HOURS_12_MINUTES_FORMAT = 'hh:mm A';
export const MONTH_DAY_YEAR_SLASH_SHORT_FORMAT = 'MM/DD/YY';
export const MONTH_DAY_YEAR_SLASH_FORMAT = 'MM/DD/YYYY';
export const MONTH_DAY_YEAR_ABBREVIATED_FORMAT = 'MMM, DD YYYY';
export const MONTH_DAY_YEAR_TIME_ABBREVIATED_FORMAT = 'MMM, DD YYYY HH:mm';

export const MONTH_DAY_ABBREVIATED_FORMAT = 'MMM DD';
export const STRAWBERRY_SOCIALS_SUPPORTED_COUNTRIES = [
    'AU',
    'BR',
    'CA',
    'CN',
    'CZ',
    'DK',
    'FI',
    'FR',
    'DE',
    'GR',
    'HK',
    'ID',
    'IE',
    'IT',
    'JP',
    'MY',
    'NL',
    'NZ',
    'NO',
    'PL',
    'PT',
    'RO',
    'RU',
    'SG',
    'RS',
    'KR',
    'ES',
    'SE',
    'TW',
    'TH',
    'UA',
    'GB',
    'US',
];
export const POST_TYPES = {
    VIDEO: 'video',
    IMAGE: 'image',
    CAROUSEL: 'carousel',
    STORY: 'story',
};
export const S3_BUCKET_URL = 'https://influencer-bidi.s3.amazonaws.com';
export const CURRENT_CDN_TECH_URL = 'https://cdn.current.tech';
export const LEGACY_CLIENTS_MIGRATED_TO_NEW_LEDGERS_SYSTEM = [1];
export const APP_HEIGHT = 'calc(100% - 170px)';
export const CONTACTS_PAGE_HEIGHT = 'calc(100% - 178px)';
export const PROSPECTS_TABLE_HEIGHT = 'calc(100% - 100px)';
export const DISCOUNT_CODES_TABLE_HEIGHT = 'calc(100vh - 285px)';
export const DISCOUNT_CODES_SETTINGS_TABLE_HEIGHT = 'calc(100vh - 220px)';
